import { PanelType } from '../../../routes/DetailsPanel';
import { TransitionProps } from './types';

export const getTransitionClass = ({
  visible,
  hasTransitionedIn,
  isNextViewRoutes,
  previousDetailsView,
}: TransitionProps): string => {
  let transitionClass = '';

  if (visible && hasTransitionedIn) {
    transitionClass = 'slide-in-right';
    if (previousDetailsView === PanelType.ROUTE_DETAILS) return '';
  } else {
    transitionClass = 'slide-out-right';
    if (isNextViewRoutes) transitionClass = 'slide-out-left';
  }

  return transitionClass;
};
